import type { TEnvelopeStep } from "@/types.ts";

export const renderEnvelope = (content: HTMLDivElement) => {
  let step: TEnvelopeStep = "intro";

  const renderers: Record<TEnvelopeStep, () => void> = {
    intro: () => {
      content.innerHTML = `
        <div class="text-center space-y-3">
          <h1 class="text-2xl text-shadow-md">No ty jsi nejúžasnější 😘</h1>
          <button id="openLetter"
            class="bg-indigo-500 text-white shadow-lg shadow-indigo-500/50 px-6 py-3 rounded-xl">
            Teď si otevři dopisek 💌
          </button>    
        </div>
      `;

      document
        .querySelector("#openLetter")!
        .addEventListener("click", () => setStep("envelope"));
    },

    envelope: () => {
      content.innerHTML = `
        <div class="flex flex-col items-center gap-6">
          <div id="envelope" class="cursor-pointer text-9xl select-none text-shadow-lg">
            💌
          </div>
        </div>
      `;

      document
        .querySelector("#envelope")!
        .addEventListener("click", () => setStep("letter"));
    },

    letter: () => {
      content.innerHTML = `
        <div class="max-w-md bg-white text-black p-8 rounded-2xl shadow-xl space-y-6 text-center pb-24">
          <h2 class="text-2xl text-shadow-md">Budeš můj valentýn? 🥺💖</h2>

          <div class="flex justify-center gap-6 mt-4">
            <button id="yesBtn"
              class="bg-green-500 text-white px-6 py-3 rounded-xl shadow-lg">
              ANO 😍
            </button>

            <button id="noBtn"
              class="bg-red-500 text-white px-6 py-3 rounded-xl shadow-lg">
              Ne 😢
            </button>
          </div>
        </div>
      `;

      const noBtn = document.querySelector<HTMLButtonElement>("#noBtn")!;
      const yesBtn = document.querySelector("#yesBtn")!;

      let scale = 1;
      let growInterval: number | null = null;

      noBtn.style.transition = "transform 0.05s linear";
      noBtn.addEventListener("mouseenter", () => {
        noBtn.innerText = "Fakt ne? 😳";
        growInterval = window.setInterval(() => {
          scale += 0.02;
          noBtn.style.transform = `scale(${scale})`;
        }, 16);
      });

      noBtn.addEventListener("mouseleave", () => {
        if (growInterval) clearInterval(growInterval);
      });

      yesBtn.addEventListener("click", () => setStep("success"));
    },

    success: () => {
      content.innerHTML = `
        <div class="text-center space-y-6">
          <h1 class="text-6xl text-shadow-lg">Jupííí 🥳❤️</h1>
          <span>(v koupelně máš schovaný dáreček :))</span>
        </div>
      `;
    }
  };

  const render = () => renderers[step]();
  const setStep = (newStep: typeof step) => {
    step = newStep;
    render();
  };

  render();
};
